"use client";

import dynamic from "next/dynamic";

const ClientOnlyPage = dynamic(() => import("./client"), { ssr: false });

export default function ClientOnlyPageWrapper(props) {
  return <ClientOnlyPage {...props} />;
}
